import { useCallback } from 'react';

const useAcceptTermsCheckboxes = ({
  acceptTerms,
  setAcceptTerms,
  acceptDataUsage,
  setAcceptDataUsage,
}) => {
  const handleTermsChange = useCallback((event) => {
    setAcceptTerms(event.target.checked);
  }, [setAcceptTerms]);

  const handleDataUsageChange = useCallback((event) => {
    setAcceptDataUsage(event.target.checked);
  }, [setAcceptDataUsage]);

  return [
    {
      id: 'accept-terms',
      checked: acceptTerms,
      onChange: handleTermsChange,
      label: 'Acepto los términos y condiciones',
    },
    {
      id: 'accept-data-usage',
      checked: acceptDataUsage,
      onChange: handleDataUsageChange,
      label: 'Doy mi consentimiento de uso de datos',
    },
  ];
};

export default useAcceptTermsCheckboxes;
